import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { user } from 'ampersand-app'
import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'
import { userLoggedOut } from '@/redux/ducks/global'

const OPEN_BUHL_MARKETPLACE_IN_NEW_TAB = false

// Extracted from subscription-item.meinbuero.tsx so the shop page's plan checkout flow (ticket
// cloning + marketplace form submit, or plain redirect) can be triggered from other places too.
export const usePlanCheckout = (formClassName?: string) => {
  const dispatch = useDispatch()
  const marketplaceFormRef = useRef<HTMLFormElement>(null)
  const [clonedBuhlTicket, setClonedBuhlTicket] = useState('')
  const [marketplaceUrl, setMarketplaceUrl] = useState('')

  const logoutUser = () => {
    const logout = () => {
      dispatch(userLoggedOut())
      user.logout(true)
    }

    if (OPEN_BUHL_MARKETPLACE_IN_NEW_TAB) {
      logout()
    } else {
      window.addEventListener('pagehide', logout, { once: true })
    }
  }

  useEffect(() => {
    if (clonedBuhlTicket) {
      marketplaceFormRef.current?.submit()
      logoutUser()
    }
  }, [clonedBuhlTicket])

  const checkout = (url: string, { isMarketplace = false } = {}) => {
    if (!url) return

    const redirectWithoutTicket = () => setTimeout(() => {
      logoutUser()
      window.open(url, OPEN_BUHL_MARKETPLACE_IN_NEW_TAB ? '_blank' : '_self')
    }, 1)

    if (isMarketplace) {
      setMarketplaceUrl(url)
      request(settingsConfig.cloneTicketForBuhlMarketplace, { auth: true, isConcurrent: true })
        .then(response => {
          const ticket = response?.body?.data
          if (ticket) {
            setClonedBuhlTicket(ticket)
          } else {
            redirectWithoutTicket()
          }
        })
        .catch(() => redirectWithoutTicket())
    } else {
      logoutUser()
      window.open(url, OPEN_BUHL_MARKETPLACE_IN_NEW_TAB ? '_blank' : '_self')
    }
  }

  const marketplaceForm = clonedBuhlTicket
    ? (
      <form className={formClassName} method='post' ref={marketplaceFormRef} action={marketplaceUrl} target={OPEN_BUHL_MARKETPLACE_IN_NEW_TAB ? '_blank' : '_self'}>
        <input type='hidden' name='BuhlTicket' value={clonedBuhlTicket} />
      </form>
    )
    : null

  return { checkout, marketplaceForm }
}
